import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { CalendarCheck, Check, X, Sparkles, ExternalLink } from "lucide-react";

function Candidate({ c, reload }) {
  const [title, setTitle] = useState(c.title);
  const [date, setDate] = useState(c.date);
  const [time, setTime] = useState(c.time || "");
  const [busy, setBusy] = useState(false);
  const publish = async () => {
    setBusy(true);
    try { await api.post(`/admin/event-candidates/${c.id}/publish`, { title, date, time }); toast.success("Published to Events"); reload(); }
    catch { toast.error("Publish failed"); setBusy(false); }
  };
  const dismiss = async () => { await api.delete(`/admin/event-candidates/${c.id}`); toast("Dismissed"); reload(); };
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 border border-white/10 bg-[#141414] p-3" data-testid={`candidate-${c.id}`}>
      <input value={title} onChange={(e) => setTitle(e.target.value)} data-testid={`cand-title-${c.id}`} className="flex-1 bg-[#0f0f0f] border border-white/10 px-2 py-1.5 text-sm text-white focus:outline-none focus:border-[#00E5FF]" />
      <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid={`cand-date-${c.id}`} className="bg-[#0f0f0f] border border-white/10 px-2 py-1.5 text-sm text-white" />
      <input value={time} onChange={(e) => setTime(e.target.value)} placeholder="Time" className="w-24 bg-[#0f0f0f] border border-white/10 px-2 py-1.5 text-sm text-white" />
      {c.source_url && <a href={c.source_url} target="_blank" rel="noopener noreferrer" className="text-neutral-500 hover:text-white" title="Source"><ExternalLink size={15} /></a>}
      <button onClick={publish} disabled={busy} data-testid={`cand-publish-${c.id}`} className="bg-[#00FF66] text-black text-xs font-bold px-3 py-1.5 flex items-center gap-1 disabled:opacity-50"><Check size={13} /> Publish</button>
      <button onClick={dismiss} data-testid={`cand-dismiss-${c.id}`} className="text-[#FF0055] hover:text-white px-2"><X size={16} /></button>
    </div>
  );
}

export default function EventsReview() {
  const [cands, setCands] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); api.get("/admin/event-candidates").then((r) => setCands(r.data)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);
  const publishAll = async () => {
    try { const { data } = await api.post("/admin/event-candidates/publish-all"); toast.success(data.message); load(); }
    catch { toast.error("Failed"); }
  };
  const groups = cands.reduce((a, c) => { (a[c.venue_name] = a[c.venue_name] || []).push(c); return a; }, {});

  return (
    <div data-testid="events-review-panel">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="font-display font-bold text-2xl text-white flex items-center gap-2"><CalendarCheck size={22} className="text-[#FF0055]" /> Events Review</h2>
          <p className="text-neutral-500 text-sm mt-1">The RiNo Ranger found these on venue websites. Edit if needed, then publish to the live Events calendar.</p>
        </div>
        {cands.length > 0 && (
          <button onClick={publishAll} data-testid="publish-all-btn" className="bg-[#FF0055] hover:bg-[#ff2d74] text-white text-sm font-semibold px-4 py-2.5 flex items-center gap-2"><Sparkles size={15} /> Publish All ({cands.length})</button>
        )}
      </div>
      {loading ? <div className="text-neutral-500 py-10 text-center">Loading…</div>
        : cands.length === 0 ? <div className="text-neutral-500 py-16 text-center border border-white/10">No pending events. Run "Harvest Menus & Events" from the Venue Bot tab.</div>
        : Object.entries(groups).map(([venue, list]) => (
          <div key={venue} className="mb-6" data-testid={`cand-group-${venue}`}>
            <h3 className="font-accent text-[#00E5FF] text-sm mb-2">{venue} <span className="text-neutral-600">({list.length})</span></h3>
            <div className="space-y-2">{list.map((c) => <Candidate key={c.id} c={c} reload={load} />)}</div>
          </div>
        ))}
    </div>
  );
}
